module.exports = __webpack_public_path__ + "static/media/skill-firebase.7cb241aa.png";